import { createConfigurable } from '@core/config-singleton/createConfigurable';

export const { config, updateConfig } = createConfigurable<{
  streamSource: 'primary' | 'multichannel';
}>({
  streamSource: 'multichannel',
});
